export default __webpack_public_path__ + "static/media/logo_jnj_white.d4adee6a.svg";